export default {
  updateLocation(state, location) {
    state.location = location || []
  },

  updateSideMenuId(state, sideMenuId) {
    state.sideMenuId = sideMenuId
  },

  updateSidebar(state, isCollapsed) {
    state.isSidebarCollapsed = isCollapsed
  },

  hideSidebar(state) {
    state.isSidebarHidden = true
  },
  showSidebar(state) {
    state.isSidebarHidden = false
  },

  hideContents(state) {
    state.isContentsHidden = true
  },
  showContents(state) {
    state.isContentsHidden = false
  },

  incrementLoadingCount(state) {
    state.loadingCount += 1
  },

  decrementLoadingCount(state) {
    if (state.loadingCount <= 0) {
      throw new Error('loadingCount must not be less than 0!')
    }

    state.loadingCount -= 1
  },
  clearLoadingCount(state) {
    state.loadingCount = 0
  },
  setSystemMessage(state, {
    message,
    color = 'red',
    timeout = 5000,
    light = false,
    global = false,
  }) {
    state.systemMessage = {
      show: true,
      message,
      color,
      timeout,
      light,
      global,
    }
  },
  resetSystemMessage(state) {
    state.systemMessage.show = false
  },
  setIgnoreResetLoading(state, value) {
    state.ignoreResetLoading = value
  },
}
